import * as React from "react";
import { cn } from "@/lib/utils";

export const Input = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, type, ...props }, ref) => (
  <input
    type={type}
    ref={ref}
    className={cn(
      "flex h-10 w-full rounded-md border border-pb-border bg-pb-surface px-3 py-2 text-sm",
      "placeholder:text-pb-ink-3",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pb-primary focus-visible:ring-offset-2 focus-visible:ring-offset-pb-bg",
      "focus:border-pb-primary",
      "transition-colors",
      "disabled:cursor-not-allowed disabled:opacity-50",
      className,
    )}
    {...props}
  />
));
Input.displayName = "Input";
